import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/cards.css';

export default function ProjectCard({ project }) {
  return (
    <div className="project-card">
      <div className="project-card-header" style={{ '--card-color': project.color }}>
        {project.image && (
          <img
            src={project.image}
            alt={project.title}
            className="project-card-image"
          />
        )}
      </div>
      <div className="project-card-body">
        <h3 className="project-card-title">{project.title}</h3>
        <span className="project-card-category-text">{project.category}</span>
        <p className="project-card-desc">{project.description}</p>
        <div className="project-stats">
          <div className="project-stat">
            <span className="stat-metric">{project.stats.metric1}</span>
            <span className="stat-label">{project.stats.label1}</span>
          </div>
          <div className="project-stat-divider" />
          <div className="project-stat">
            <span className="stat-metric">{project.stats.metric2}</span>
            <span className="stat-label">{project.stats.label2}</span>
          </div>
        </div>
        <div className="project-tags">
          {project.tags.map(tag => (
            <span key={tag} className="project-tag">{tag}</span>
          ))}
        </div>
        <Link to={`/projects/${project.slug}`} className="project-view-btn">
          View Project
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Link>
      </div>
    </div>
  );
}